import {  mapInteraction } from "./backendPayload";

export function buildInreviewInteractionPayload(interaction,status) {
  const backendInteraction = mapInteraction(interaction, interaction.id);
  if (!backendInteraction) return null;
  return {
    InteractionId: interaction.id,
    Interaction: JSON.stringify(backendInteraction),
    VideoInteractionType: backendInteraction.type,
    VideoInteractionStatus:status
  };
}
